import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { Modal, Button, List } from "antd-mobile";
import _ from "underscore";
import { Icon } from "antd";
import moment from "moment";
import { RenderAddon, RenderNotes } from "./Addon";
import "./SuccessInfo.css";

const TOP_HEIGHT = 40;
const BOTTOM_HEIGHT = 40;
const Item = List.Item;
const Brief = Item.Brief;

class SuccessInfo extends React.Component {
  constructor(props) {
    super(props);

    // Get user email from social data or order
    const social = props.cartStore.menuStore.social || {};
    const orderEmail = props.order && props.order.email;
    const userEmail = social.email || orderEmail || "";

    this.state = {
      email: userEmail,
      emailSubmitted: false,
      emailError: "",
      isSubmitting: false, // Thêm flag để ngăn submit nhiều lần
    };

    // Get order ID for tracking email submission per order
    this.orderId = props.order && props.order.id;
    
    // Thêm debounce timer để ngăn spam
    this.submitTimer = null;
    this.lastSubmitTime = 0;
  }

  componentDidMount() {
    // Try to get tax config from localStorage
    this.taxConfigFromLocalStorage = null;
    try {
      const controller = this.props.cartStore.menuStore.controller;
      const taxConfigKey = `${controller}_taxConfig`;
      const taxConfigStr = localStorage.getItem(taxConfigKey);
      if (taxConfigStr) {
        const taxConfig = JSON.parse(taxConfigStr);
        if (taxConfig && taxConfig.data) {
          this.taxConfigFromLocalStorage = taxConfig.data;
        }
      }
    } catch (e) {
      console.error("Error parsing tax config from localStorage:", e);
    }
    this.checkEmailSubmissionStatus();
  }

  componentWillUnmount() {
    // Cleanup timer khi component unmount
    if (this.submitTimer) {
      clearTimeout(this.submitTimer);
    }
  }

  // Modern notification function
  showNotification = (message, type = "info") => {
    // Tạo notification element
    const notification = document.createElement("div");
    notification.className = `notification notification-${type}`;
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === "success" ? "#4caf50" : "#f44336"};
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      z-index: 9999;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 14px;
      max-width: 300px;
      word-wrap: break-word;
      animation: slideIn 0.3s ease-out;
    `;
    
    // Thêm CSS animation
    const style = document.createElement("style");
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOut {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
    
    notification.textContent = message;
    document.body.appendChild(notification);
    
    // Auto remove sau 4 giây
    setTimeout(() => {
      notification.style.animation = "slideOut 0.3s ease-in";
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 4000);
  }

  // Email validation function
  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle email input change
  handleEmailChange = (e) => {
    const email = e.target.value;
    this.setState({
      email,
      emailError: "", // Clear error when user types
    });
  };

  // Check email submission status for this specific order
  checkEmailSubmissionStatus = () => {
    if (!this.orderId) return;
    try {
      const emailSubmissionKey = `email_submitted_${this.orderId}`;
      const emailSubmitted = localStorage.getItem(emailSubmissionKey);
      if (emailSubmitted === "true") {
        this.setState({ emailSubmitted: true });
// console.log(`Email already submitted for order ${this.orderId}`);
      }
    } catch (e) {
      console.error("Error checking email submission status:", e);
    }
  };

  // Gửi thông tin order về API backend để gửi email
  sendOrderReceiptToAPI = async () => {
    const { cartStore, order } = this.props;
    const controllerId = cartStore.menuStore.controller;
    const orderId = order && order.id;
    const email = this.state.email;

    // Kiểm tra đang submit
    if (this.state.isSubmitting) {
      return;
    }

    // Kiểm tra đã submit cho order này chưa
    if (this.state.emailSubmitted) {
      return;
    }

    // Kiểm tra thời gian giữa các lần submit (tối thiểu 2 giây)
    const now = Date.now();
    if (now - this.lastSubmitTime < 2000) {
      this.setState({ emailError: "Please wait a moment before trying again." });
      return;
    }

    // Kiểm tra input
    if (!controllerId || !orderId || !email) {
      this.setState({ emailError: "Please enter your email address" });
      return;
    }

    if (!this.validateEmail(email)) {
      this.setState({ emailError: "Please enter a valid email address" });
      return;
    }

    // Clear previous timer
    if (this.submitTimer) {
      clearTimeout(this.submitTimer);
    }

    // Set submitting state
    this.setState({ 
      isSubmitting: true, 
      emailError: "" 
    });
    this.lastSubmitTime = now;

    try {
      const response = await fetch(
        "https://fzorder.foodzaps.com/v13_mobile/online/call/" + controllerId,
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: `action=notify_customer&controller_id=${encodeURIComponent(
            controllerId
          )}&order_id=${encodeURIComponent(orderId)}&name=${encodeURIComponent(
            email
          )}|${encodeURIComponent(orderId)}&tag=receipt`,
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await response.text();
// console.log("API response:", result);
      
      // Mark as submitted
      this.setState({ 
        emailSubmitted: true, 
        emailError: "",
        isSubmitting: false 
      });

      // Save submission status to localStorage
      if (this.orderId) {
        try {
          const emailSubmissionKey = `email_submitted_${this.orderId}`;
          localStorage.setItem(emailSubmissionKey, "true");
        } catch (e) {
          console.error("Error saving email submission status:", e);
        }
      }

      if (window.Toast) {
        window.Toast.success("Receipt email request sent successfully!");
      } else {
        // Sử dụng modern notification thay vì alert
        this.showNotification("Receipt email request sent successfully!", "success");
      }
    } catch (e) {
      console.error("Error sending order receipt to API:", e);
      this.setState({
        emailError: "Failed to send receipt. Please try again.",
        isSubmitting: false
      });
    }
  };

  renderItems() {
    let { cartStore, order } = this.props;
    return _.map(order.cartEntries, (entry, index) => (
      <Fragment key={`${entry.item.id}-${index}`}>
        <OrderItem entry={entry} cartStore={cartStore} />
      </Fragment>
    ));
  }

  // Hàm lấy giá trị an toàn từ nhiều key
  getValue = (obj, keys, defaultValue = 0) => {
    for (let key of keys) {
      if (obj && obj[key] !== undefined && obj[key] !== null) return obj[key];
    }
    return defaultValue;
  };

  // Generate receipt HTML (robust, giống UI app)
  generateReceiptHTML = (orderData, orderId) => {
    const itemsHTML = orderData.items
      .map(
        (item) => `
      <tr>
        <td style="padding: 8px 0;">
          <strong>${item.name}</strong> x${item.quantity}
        </td>
        <td style="text-align: right; color: #333;">
          $${Number(item.originalPrice).toFixed(2)}
          ${
            item.discount && Number(item.discount) > 0
              ? `<span style="color: red;"> -$${Number(item.discount).toFixed(
                  2
                )}</span>`
              : ""
          }
        </td>
        <td style="text-align: right; color: #333;">
          <strong>$${Number(item.finalPrice).toFixed(2)}</strong>
        </td>
      </tr>
    `
      )
      .join("");

    // Membership savings section - support multiple rewards
    let membershipSavingsHTML = "";
    const hasEwallet = Number(orderData.ewallet) !== 0;
    const hasMemberPrice = Number(orderData.memberPrice) !== 0;
    
    // Check if we have multiple rewards from cartStore
    let hasMultipleRewards = false;
    let multipleRewardsHTML = "";
    
    // Try to get cartStore from various sources
    let cartStore = null;
    if (this.props && this.props.cartStore) {
      cartStore = this.props.cartStore;
    }
    
    if (cartStore && cartStore.appliedRewardsBreakdown) {
      const appliedRewardsBreakdown = cartStore.appliedRewardsBreakdown || [];
      if (appliedRewardsBreakdown.length > 0) {
        hasMultipleRewards = true;
        multipleRewardsHTML = appliedRewardsBreakdown.map(reward => 
          `<div class="cart-link-item membership-savings-section"><span class="cart-link-label">• ${reward.name}</span><span class="cart-link-value">-$${(parseFloat(reward.amount) || 0).toFixed(2)}</span></div>`
        ).join('');
      }
    }
    
    if (hasMultipleRewards || hasEwallet || hasMemberPrice) {
      membershipSavingsHTML = `
      <div class="membership-savings" style="margin-top:10px;">
        <div class="cart-link-item"><span class="cart-link-label">Membership Savings</span></div>
        ${multipleRewardsHTML}
        ${
          !hasMultipleRewards && hasEwallet
            ? `<div class="cart-link-item membership-savings-section"><span class="cart-link-label">• E-Wallet Redemption</span><span class="cart-link-value">-$${Number(
                orderData.ewallet
              ).toFixed(2)}</span></div>`
            : ""
        }
        ${
          hasMemberPrice
            ? `<div class="cart-link-item membership-savings-section"><span class="cart-link-label">• Member Price</span><span class="cart-link-value">-$${Number(
                orderData.memberPrice
              ).toFixed(2)}</span></div>`
            : ""
        }
      </div>
    `;
    }

    return `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <thead>
            <tr>
              <th style="text-align: left; color: #333;">Item</th>
              <th style="text-align: right; color: #333;">Price</th>
              <th style="text-align: right; color: #333;">Final</th>
            </tr>
          </thead>
          <tbody>
            ${itemsHTML}
          </tbody>
        </table>
        <hr style="border: none; border-top: 1px solid #eee; margin: 20px 0;">
        <div class="cart-links" style="margin-bottom: 10px;">
          <div class="cart-link-item"><span class="cart-link-label">SubTotal</span><span class="cart-link-value">$ ${Number(
            orderData.subtotal
          ).toFixed(2)}</span></div>
          <div class="cart-link-item"><span class="cart-link-label">GST Inclusive <span class="cart-link-percent"> (9%)</span></span><span class="cart-link-value">$ ${Number(
            orderData.tax
          ).toFixed(2)}</span></div>
          ${membershipSavingsHTML}
        </div>
        <div style="text-align: right; font-size: 18px; margin-top: 10px;">Total: <strong>$${Number(
          orderData.total
        ).toFixed(2)}</strong></div>
      </div>
    `;
  };

  // Generate order summary text (robust)
  generateOrderSummary = (orderData) => {
    const itemsList = orderData.items
      .map((item) => {
        const price =
          item.finalPrice !== undefined && item.finalPrice !== null
            ? item.finalPrice
            : item.originalPrice !== undefined && item.originalPrice !== null
            ? item.originalPrice
            : 0;
        return `${item.name} x${item.quantity} - $${Number(price).toFixed(2)}`;
      })
      .join(", ");

    return `Order Summary: ${itemsList}. Total: $${Number(
      orderData.total
    ).toFixed(2)}`;
  };

  render() {
    let { cartStore, order } = this.props;
    let showRepeatBtn = cartStore.menuStore.showRepeatBtn;

    let widper = "100%";
    let isCheck = cartStore.menuStore.getDiffeOrderTime(order);
    if (isCheck && showRepeatBtn) {
      widper = "33%";
    } else if (isCheck || showRepeatBtn) {
      widper = "50%";
    }
    let receipt = {};
    try {
      receipt = JSON.parse(order.priceReceipt);
    } catch (err) {
      receipt = {};
    }
    let totalamt = receipt && receipt.total ? receipt.total.toFixed(2) : "0.00";
    if (totalamt < 0) {
      totalamt = "0.00";
    }
// console.log(order);

    // Calculate membership savings using the same logic as PaymentOption
    let totalMembershipSavings = 0;
    try {
      // Check if user is logged in first
      const social = cartStore.menuStore.social || {};
      const isLoggedIn = cartStore.menuStore.isLoginModalVisible === false &&
        social && Object.keys(social).length > 0;
      
      let cartEntries = order.cartEntries;
      // console.log('[SuccessInfo] 🔍 cartEntries:', cartEntries);
      if (isLoggedIn && cartEntries && cartEntries.length > 0) {
        // Import the computeMembershipSavings function logic
        const { toJS } = require('mobx');
        
        // Helper functions for robust addon processing
        function toArr(v) {
          if (!v) return [];
          if (typeof v.slice === 'function') return v.slice(); // works for ObservableArray
          return Array.isArray(v) ? v : [v];
        }
        function cents(n) { return Math.round((Number(n) || 0) * 100); }

        // Pure function to compute membership savings with proper rounding
        function computeMembershipSavings(entries) {
          let totalCents = 0;
          // console.log('[SuccessInfo] 🔧 Starting computeMembershipSavings with entries:', entries.length);

          entries.forEach((entry, index) => {
                          // console.log(`[SuccessInfo] 🔧 Processing entry ${index}:`, (entry.item ? entry.item.name : undefined), 'qty:', entry.quantity);
              // console.log(`[SuccessInfo] 🔧 Entry ${index} full structure:`, JSON.stringify(entry, null, 2));
            // Try to get quantity from multiple possible sources
            let qty = Number(entry.quantity) || Number(entry.qty) || Number((entry.item ? entry.item.quantity : undefined));
            
            // If quantity is not found, try to calculate from addons length
            if (!qty || qty === 0) {
              // console.log(`[SuccessInfo] 🔧 Entry ${index} - Calculating qty from addons`);
              // console.log(`[SuccessInfo] 🔧 Entry ${index} - addons type:`, typeof entry.addons, 'isArray:', Array.isArray(entry.addons));
              // console.log(`[SuccessInfo] 🔧 Entry ${index} - addons value:`, entry.addons);
              
              // Check if it's a simple array (even if Array.isArray fails)
              if (entry.addons && (Array.isArray(entry.addons) || (typeof entry.addons === 'object' && entry.addons.length !== undefined && typeof entry.addons.length === 'number'))) {
                // For simple addon arrays, count the length
                qty = entry.addons.length || 1;
                // console.log(`[SuccessInfo] 🔧 Entry ${index} - Simple addon array, length:`, entry.addons.length, 'qty:', qty);
              } else if (entry.addons && typeof entry.addons === 'object' && !Array.isArray(entry.addons) && entry.addons.length === undefined) {
                // For complex addon structures, count total addons across all groups
                let totalAddons = 0;
                Object.keys(entry.addons).forEach(groupKey => {
                  const group = entry.addons[groupKey];
                  if (Array.isArray(group)) {
                    totalAddons += group.length;
                  }
                });
                qty = totalAddons || 1;
                                  // console.log(`[SuccessInfo] 🔧 Entry ${index} - Complex addon object, total addons:`, totalAddons, 'qty:', qty);
              } else {
                // Fallback: try to count from notes array
                if (entry.notes && Array.isArray(entry.notes)) {
                  qty = entry.notes.length || 1;
                  // console.log(`[SuccessInfo] 🔧 Entry ${index} - Using notes array, length:`, entry.notes.length, 'qty:', qty);
                }
              }
            } else {
              // console.log(`[SuccessInfo] 🔧 Entry ${index} - Using existing qty:`, qty);
            }
            
            // Fallback to 1 if still no quantity found
            qty = qty || 1;
                          // console.log(`[SuccessInfo] 🔧 Entry ${index} final qty:`, qty);
            const item = entry.item || {};
            const itemPrice = Number(item.price) || 0;
            const priceOptions = toArr(item.priceOptions);

            const std = priceOptions.find(o => o && String(o.name).toLowerCase() === "standard");
            const mem = priceOptions.find(o => o && String(o.name).toLowerCase() === "membership");

            // ✅ Only apply item-level diff for non–zero-base items
            if (itemPrice > 0 && std && mem) {
              const diff = Number(std.price) - Number(mem.price);
              totalCents += cents(diff) * qty;
                              // console.log(`[SuccessInfo] 🔧 Item savings:`, item.name, 'Std:', std.price, 'Mem:', mem.price, 'Diff:', diff, 'Qty:', qty, 'Total:', (cents(diff) * qty) / 100);
            }

            // Addon savings (once), multiplied by entry qty
            const addonMap = new Map();
            
            toArr(entry.addons).forEach(groupObj => {
              if (!groupObj || typeof groupObj !== "object") return;
              Object.keys(groupObj).forEach(cat => {
                toArr(groupObj[cat]).forEach(addon => {
                  if (!addon || !addon.hasMembershipPricing) return;
                  
                  const addonId = addon.id || addon.name;
                  const existingAddon = addonMap.get(addonId);
                  
                  if (existingAddon) {
                    existingAddon.quantity = (Number(existingAddon.quantity) || 0) + (Number(addon.quantity) || 0);
                  } else {
                    addonMap.set(addonId, { ...addon });
                  }
                });
              });
            });
            
            addonMap.forEach(addon => {
              const diff = Number(addon.standardPrice) - Number(addon.membershipPrice);
              const addonQty = Number(addon.quantity) || 0;
              const addonSavings = cents(diff) * addonQty;
              totalCents += addonSavings;
                                // console.log(`[SuccessInfo] 🔧 Addon savings:`, addon.name, 'Std:', addon.standardPrice, 'Mem:', addon.membershipPrice, 'Diff:', diff, 'Qty:', addonQty, 'Total:', addonSavings / 100);
            });
          });

          return totalCents / 100;
        }

        totalMembershipSavings = computeMembershipSavings(cartEntries);
                    // console.log('[SuccessInfo] 📊 Final totalMembershipSavings:', totalMembershipSavings);
      }
    } catch (error) {
// console.log("Error calculating membership savings:", error);
      totalMembershipSavings = 0;
    }
    return (
      <Modal
        visible={this.props.visible}
        style={{
          overflow: "hidden",
          height: "100%",
          textAlign: "left",
          wordBreak: "break-all",
        }}
        className="successModel"
      >
        <div
          style={{
            position: "fixed",
            top: 0,
            height: `${TOP_HEIGHT}px`,
            width: "100%",
          }}
        >
          {cartStore.menuStore.layout === 4 ? (
            <div className="info_header">
              <span
                className="backBtn"
                onClick={() => {
                  this.props.closeModal();
                  setTimeout(() => {
                    this.props.showTabsPage('order');
                  }, 100);
                }}
              >
                <Icon
                  key="1"
                  type="back"
                  style={{ fontSize: "25px", color: "#fff" }}
                />
              </span>
              <span className="logoclass">
                <img
                  src={cartStore.menuStore.getLogo()}
                  alt="logo"
                  style={{ height: "40px" }}
                  onClick={() => {
                    this.props.closeModal();
                  }}
                />
              </span>
              <span className="homeclass">
                <Icon
                  key="1"
                  type="home"
                  style={{ fontSize: "25px", color: "#fff" }}
                  onClick={() => {
                    this.props.closeModal();
                  }}
                />{" "}
              </span>
            </div>
          ) : (
            <div className="info_header">
              {this.props.translation.success}
              <span
                className="info_close"
                onClick={() => {
                  this.props.closeModal();
                }}
              >
                {this.props.translation.x}
              </span>{" "}
            </div>
          )}

          <div
            style={{
              position: "fixed",
              overflow: "scroll",
              height: "calc(100% - 170px)",
              width: "100%",
            }}
            className="thankyouscreen"
          >
            {cartStore.menuStore.layout === 4 ? (
              <div
                style={{ paddingTop: 15, maxWidth: 480, margin: "0 auto" }}
                className="orderItems"
              >
                {order.isNew && (
                  <div className="thanksclass">
                    <span className="welcomemsg">
                      <h2>Thank you!</h2>Your order has been placed.
                    </span>
                  </div>
                )}
                <p className="dateheading">
                  <span className="orderids">Order ID {order.id} </span>
                  <span className="dateorder">
                    {moment(order.time, "DD/MM/YYYY HH:mm:ss").format(
                      "DD MMM, HH:mm"
                    )}
                  </span>
                </p>
                {this.renderItems()}

                {/* Email Input Section */}
                {!this.state.emailSubmitted && this.props.cartStore.menuStore.isEmailReceiptEnable() && (
                  <div className="emailSection">
                    <hr className="cart-links-divider" />
                    <div className="emailInputContainer">
                      <h4 className="emailTitle">Get a copy of your receipt</h4>

                      <div className="emailInputWrapper">
                        <input
                          type="email"
                          className="emailInput"
                          placeholder="Enter your email address"
                          value={this.state.email}
                          onChange={this.handleEmailChange}
                          disabled={this.state.emailSubmitted || this.state.isSubmitting}
                          style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap"
                          }}
                        />
                        <button
                          className="emailSubmitBtn"
                          onClick={this.sendOrderReceiptToAPI}
                          disabled={this.state.emailSubmitted || this.state.isSubmitting}
                          style={{
                            minWidth: "80px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                          }}
                        >
                          {this.state.isSubmitting ? "Sending..." : "Send"}
                        </button>
                      </div>

                      {this.state.emailError && (
                        <div className="emailError">
                          {this.state.emailError}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {this.state.emailSubmitted && this.props.cartStore.menuStore.isEmailReceiptEnable() && (
                  <div className="emailSuccessSection">
                    <hr className="cart-links-divider" />
                    <div className="emailSuccessContainer">
                      <div className="emailSuccessIcon">✓</div>
                      <p className="emailSuccessText">
                        Email sent successfully! Check your inbox for the receipt.
                      </p>
                    </div>
                  </div>
                )}

                <div className="priceInfo">
                  <hr className="cart-links-divider" />
                  <div className="cart-links">
                    {/* SubTotal */}
                    <div className="cart-link-item">
                      <span className="cart-link-label">
                        {receipt && receipt.sub_name ? receipt.sub_name : "SubTotal"}
                      </span>
                      <span className="cart-link-value">
                        {cartStore.menuStore.currencySymbol}{" "}
                        {(() => {
                          // Check if user is logged in
                          const social = cartStore.menuStore.social || {};
                          const isLoggedIn = cartStore.menuStore.isLoginModalVisible === false &&
                            social && Object.keys(social).length > 0;
                          
                          // Only add membership savings if user is logged in
                          const membershipAdjustment = isLoggedIn ? totalMembershipSavings : 0;
                          
                          return receipt && receipt.sub
                            ? parseFloat((receipt.sub || 0) + membershipAdjustment).toFixed(2)
                            : "0.00";
                        })()}
                      </span>
                    </div>

                    {/* Service Charge if applicable - only show if rate exists and amount > 0 */}
                    {(() => {
                      // First check if receipt has service charge data
                      if (
                        receipt && receipt.taxBefore &&
                        parseFloat(receipt.taxBefore).toFixed(2) > 0
                      ) {
                        return (
                          <div className="cart-link-item">
                            <span className="cart-link-label">
                              {receipt && receipt.taxBefore_name ? receipt.taxBefore_name : "Service Charge"}
                              {receipt && receipt.taxBefore_rate && (
                                <span className="cart-link-percent">
                                  {" "}
                                  ({receipt.taxBefore_rate})
                                </span>
                              )}
                            </span>
                            <span className="cart-link-value">
                              {cartStore.menuStore.currencySymbol}{" "}
                              {parseFloat(receipt && receipt.taxBefore ? receipt.taxBefore : 0).toFixed(2)}
                            </span>
                          </div>
                        );
                      }
                      return null;
                    })()}

                    {/* GST tax section - use receipt.tax1 directly like Service Charge */}
                    {(() => {
                      if (
                        receipt && receipt.tax1 &&
                        parseFloat(receipt.tax1).toFixed(2) > 0
                      ) {
                        return (
                          <div className="cart-link-item">
                            <span className="cart-link-label">
                              {receipt && receipt.tax1_name ? receipt.tax1_name : "GST"}
                              {receipt && receipt.tax1_rate && (
                              <span className="cart-link-percent">
                                {" "}
                                  ({receipt.tax1_rate})
                              </span>
                              )}
                            </span>
                            <span className="cart-link-value">
                              {cartStore.menuStore.currencySymbol}{" "}
                              {parseFloat(receipt && receipt.tax1 ? receipt.tax1 : 0).toFixed(2)}
                            </span>
                          </div>
                        );
                      }
                      return null;
                    })()}

                    {/* SST tax section - only show if tax percentage isn't zero */}
                    {(() => {
                      if (
                        this.taxConfigFromLocalStorage &&
                        this.taxConfigFromLocalStorage.pref_tax2_percentage !==
                          0
                      ) {
                        const taxPercentage =
                          this.taxConfigFromLocalStorage.pref_tax2_percentage;
                        const isInclusive = taxPercentage < 0;
                        const taxName =
                          this.taxConfigFromLocalStorage.pref_tax2_name ||
                          (isInclusive ? "SST Inclusive" : "SST");

                        // Calculate tax amount based on base subtotal (NOT including membership savings)
                        let taxAmount = 0;
                        if (receipt && receipt.sub) {
                          const baseSubTotal = parseFloat(receipt.sub);
                          if (isInclusive) {
                            // For inclusive tax: tax amount = subtotal - (subtotal / (1 + tax%/100))
                            const absPercentage = Math.abs(taxPercentage) / 100;
                            taxAmount =
                              baseSubTotal - baseSubTotal / (1 + absPercentage);
                          } else {
                            // For exclusive tax: tax amount = subtotal * tax%/100
                            taxAmount = baseSubTotal * (taxPercentage / 100);
                          }
                        }

                        return (
                          <div className="cart-link-item">
                            <span className="cart-link-label">
                              {taxName}
                              <span className="cart-link-percent">
                                {" "}
                                ({Math.abs(taxPercentage)}%)
                              </span>
                            </span>
                            <span className="cart-link-value">
                              {cartStore.menuStore.currencySymbol}{" "}
                              {taxAmount.toFixed(2)}
                            </span>
                          </div>
                        );
                      }
                      // If no tax percentage or zero percentage, don't show
                      return null;
                    })()}

                    {/* Membership Savings and Discount Section */}
                    {(() => {
                      try {
                        // let cartEntries = null;
                        let cartEntriesSource = null;

// console.log("Order data:", order);
// console.log("Props:", this.props);

                        // Try to get cart entries from multiple possible sources
                        if (order && order.cartEntries) {
// console.log("Found cartEntries in order.cartEntries");
                          cartEntriesSource = order.cartEntries;
                        } else if (
                          order &&
                          order.toJS &&
                          typeof order.toJS === "function"
                        ) {
                          // Try to convert MobX object to plain JavaScript object
                          try {
                            const plainOrder = order.toJS();
// console.log(
//                              "Converted MobX order to plain object:",
//                              plainOrder
//                            );
                            if (plainOrder.cartEntries) {
                              cartEntriesSource = plainOrder.cartEntries;
// console.log(
//                                "Found cartEntries in plainOrder.cartEntries"
//                              );
                            }
                          } catch (e) {
                            console.error("Error converting MobX order:", e);
                          }
                        }

// console.log("Cart entries source:", cartEntriesSource);
                        if (cartEntriesSource) {
                          // Simple conversion - just get the array without deep conversion
                          // let cartEntries = [];

                          // Handle MobX observable arrays - commented out since cartEntries is not used
                          // if (
                          //   typeof cartEntriesSource === "object" &&
                          //   typeof cartEntriesSource.slice === "function"
                          // ) {
                          //   cartEntries = cartEntriesSource.slice();
                          // } else if (Array.isArray(cartEntriesSource)) {
                          //   cartEntries = cartEntriesSource.slice();
                          // } else if (
                          //   cartEntriesSource &&
                          //   typeof cartEntriesSource[Symbol.iterator] ===
                          //     "function"
                          // ) {
                          //   cartEntries = Array.from(cartEntriesSource);
                          // } else {
                          //   return null;
                          // }
                        }

                        // Get social provider info - required for membership display
                        const social = cartStore.menuStore.social || {};
                        const isAdvocadoProvider =
                          social && social.provider === "advocado";
                        const isUserLoggedIn = !!cartStore.menuStore.social;

// console.log("Social provider:", social);
// console.log(
//                          "Is advocado provider:",
//                          isAdvocadoProvider
//                        );
// console.log("Is user logged in:", isUserLoggedIn);
// console.log(
//                          "Total membership savings calculated:",
//                          totalMembershipSavings
//                        );

                        // Check if we have any discount or membership savings
                        const hasDiscount =
                          receipt && receipt.discount &&
                          parseFloat(receipt.discount) !== 0;

                        // Only show membership discount if all conditions are met:
                        // 1. User is logged in
                        // 2. Social provider is advocado
                        // 3. There are actual savings calculated
                        const hasMemberDiscount =
                          isUserLoggedIn &&
                          isAdvocadoProvider &&
                          totalMembershipSavings > 0;

// console.log("Has discount:", hasDiscount);
// console.log("Has member discount:", hasMemberDiscount);

                        return (
                          <div className="membership-savings">
                            <div className="cart-link-item">
                              <span className="cart-link-label">
                                Membership Savings
                              </span>
                            </div>

                            {/* Display multiple rewards breakdown */}
                            {(() => {
                              if (isAdvocadoProvider) {
                                // Use appliedRewardsBreakdown for multiple rewards
                                const appliedRewardsBreakdown = cartStore.appliedRewardsBreakdown || [];
                                return appliedRewardsBreakdown.map((reward, index) => (
                                  <div className="cart-link-item membership-savings-section" key={`reward-saving-${index}`}>
                                    <span className="cart-link-label">
                                      • {reward.name}
                                    </span>
                                    <span className="cart-link-value">
                                      -{cartStore.menuStore.currencySymbol}
                                      {(parseFloat(reward.amount) || 0).toFixed(2)}
                                    </span>
                                  </div>
                                ));
                              } else if (
                                hasDiscount &&
                                receipt && parseFloat(receipt.discount) !== 0
                              ) {
                                // Fallback for non-advocado providers
                                return (
                                  <div className="cart-link-item membership-savings-section">
                                    <span className="cart-link-label">
                                      •{" "}
                                      {receipt && (receipt.discount_note ||
                                        receipt.discount_name) || "Rebate"}
                                    </span>
                                    <span className="cart-link-value">
                                      -{cartStore.menuStore.currencySymbol}
                                      {Math.abs(
                                        parseFloat(receipt && receipt.discount || 0)
                                      ).toFixed(2)}
                                    </span>
                                  </div>
                                );
                              }
                              return null;
                            })()}

                            {(() => {
                              if (
                                hasMemberDiscount &&
                                totalMembershipSavings > 0
                              ) {
                                return (
                                  <div className="cart-link-item membership-savings-section">
                                    <span className="cart-link-label">
                                      • {"Member Price"}
                                    </span>
                                    <span className="cart-link-value">
                                      -{cartStore.menuStore.currencySymbol}
                                      {totalMembershipSavings.toFixed(2)}
                                    </span>
                                  </div>
                                );
                              }
                              return null;
                            })()}
                          </div>
                        );
                      } catch (error) {
                        console.error(
                          "Error in membership savings section:",
                          error
                        );
                        return null;
                      }
                    })()}
                  </div>

                  <hr className="cart-links-divider" />

                  {/* Total Payment with special styling */}
                  <div className="cart-total-item">
                    <span className="cart-total-label">
                      {receipt && receipt.total_name ? receipt.total_name : "Total Payment"}
                    </span>
                    <span className="cart-total-value">
                      {cartStore.menuStore.currencySymbol}
                      {parseFloat(receipt && receipt.total ? receipt.total : 0).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ paddingTop: 15, maxWidth: 480, margin: "0 auto" }}>
                <div
                  style={{ padding: 9 }}
                  dangerouslySetInnerHTML={{
                    __html: decodeURIComponent(this.props.receipt),
                  }}
                />{" "}
              </div>
            )}
          </div>
          <div
            className="bottom"
            style={{
              position: "fixed",
              height: `${BOTTOM_HEIGHT}px`,
              bottom: 0,
              paddingTop: 6,
              width: "100%",
            }}
          >
            <div
              style={{
                position: "absolute",
                bottom: 0,
                padding: 3,
                width: "100%",
              }}
            >
              {cartStore.menuStore.layout !== 4 && (
                <Button
                  className="bottomBtn"
                  style={{ width: widper, float: "left" }}
                  onClick={() => {
                    this.props.closeModal();
                  }}
                >
                  {cartStore.menuStore.customTexts["order_received"] !==
                    undefined &&
                  cartStore.menuStore.customTexts["order_received"] !== ""
                    ? cartStore.menuStore.customTexts["order_received"]
                    : this.props.translation.close}
                </Button>
              )}
              {isCheck ? (
                <Button
                  className="bottomBtn"
                  style={{ width: widper, float: "left" }}
                  onClick={() => {
                    this.props.checkOrderModal();
                  }}
                >
                  {this.props.cartStore.menuStore.translation.last_order_btn}
                </Button>
              ) : (
                ""
              )}
              {showRepeatBtn && cartStore.menuStore.layout !== 4 && (
                <Button
                  className="bottomBtn"
                  style={{ width: widper }}
                  onClick={() => {
                    this.props.repeatOrderFun();
                    this.props.closeModal();
                  }}
                >
                  {this.props.cartStore.menuStore.translation.repeat_order_btn}
                </Button>
              )}

              {cartStore.menuStore.layout === 4 && (
                <Button
                  className="bottomBtn"
                  style={{ width: widper }}
                  onClick={() => {
                    this.props.closeModal();
                  }}
                >
                  {this.props.cartStore.menuStore.translation.close}
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
const OrderItem = observer(({ entry, cartStore }) => {
  let item = entry.item;
  let total = cartStore.entryTotal(entry);
  let { actualPrice, priceAmt } = cartStore.calculateRewardDiscoutPrice(
    entry.reward,
    total
  );

  // Check for membership price options - enhanced for addon items
  let standardPrice = parseFloat(actualPrice) || 0;
  let membershipPrice = parseFloat(priceAmt);
  let hasMembershipDiscount = false;
  let priceDifference = 0;
  let showMembershipDiscount = false;

  // Check if logged in and social provider is appropriate
  const social = cartStore.menuStore.social || {};
  const isAdvocadoProvider = social && social.provider === "advocado";
  const isUserLoggedIn = !!cartStore.menuStore.social;

  // First, check if item has direct addon membership pricing properties
  if (item && item.hasMembershipPricing && item.standardPrice !== undefined && item.membershipPrice !== undefined) {
    standardPrice = parseFloat(item.standardPrice) || 0;
    membershipPrice = parseFloat(item.membershipPrice.price || item.membershipPrice) || 0;
    hasMembershipDiscount = standardPrice > membershipPrice;
    priceDifference = (standardPrice - membershipPrice).toFixed(2);
    showMembershipDiscount = isUserLoggedIn && isAdvocadoProvider && hasMembershipDiscount;
      
                    // console.log('[SuccessInfo] Found direct membership pricing:', item.name, 'Standard:', standardPrice, 'Member:', membershipPrice);
  } else if (item && item._membershipPricingData) {
    // Fallback: Check for stored membership data (in case of computed property conflicts)
    const data = item._membershipPricingData;
    standardPrice = parseFloat(data.standardPrice) || 0;
    membershipPrice = parseFloat(data.membershipPrice.price || data.membershipPrice) || 0;
    hasMembershipDiscount = standardPrice > membershipPrice;
    priceDifference = (standardPrice - membershipPrice).toFixed(2);
    showMembershipDiscount = isUserLoggedIn && isAdvocadoProvider && hasMembershipDiscount;
      
                    // console.log('[SuccessInfo] Found fallback membership pricing data:', item.name, 'Standard:', standardPrice, 'Member:', membershipPrice);
  } else if (item && item.priceOptions) {
    // Fallback: Check if item has price options with membership pricing
    const priceOptions = item.priceOptions;
    let convertedPriceOptions = [];
    if (Array.isArray(priceOptions)) {
      convertedPriceOptions = priceOptions.slice();
    } else if (priceOptions && typeof priceOptions.slice === "function") {
      // MobX ObservableArray has slice method
      convertedPriceOptions = priceOptions.slice();
    } else if (priceOptions && typeof priceOptions.toJS === "function") {
      // MobX ObservableArray has toJS method
      convertedPriceOptions = priceOptions.toJS();
    } else if (
      priceOptions &&
      typeof priceOptions[Symbol.iterator] === "function"
    ) {
      // Iterable (including MobX ObservableArray)
      convertedPriceOptions = Array.from(priceOptions);
    }

    const standardOption = convertedPriceOptions.find(
      (opt) => opt && opt.name && String(opt.name).toLowerCase().includes("standard")
    );
    const membershipOption = convertedPriceOptions.find(
      (opt) =>
        opt && opt.name && String(opt.name).toLowerCase().includes("membership")
    );

    if (standardOption && membershipOption) {
      standardPrice = parseFloat(standardOption.price) || 0;
      membershipPrice = parseFloat(membershipOption.price) || 0;
      hasMembershipDiscount = standardPrice > membershipPrice;
      priceDifference = (standardPrice - membershipPrice).toFixed(2);
      showMembershipDiscount = isUserLoggedIn && isAdvocadoProvider && hasMembershipDiscount;
    }
  } else if (entry.addons && entry.addons.length > 0) {
    // Special handling for addon items (like Kopi O)
    // Check if any addon has membership pricing
    let totalStandardPrice = 0;
    let totalMembershipPrice = 0;
    let hasAddonMembershipPricing = false;

    // Process addons to find membership pricing
    if (Array.isArray(entry.addons)) {
      // Simple addon array
      entry.addons.forEach(addon => {
        if (addon && addon.hasMembershipPricing) {
          hasAddonMembershipPricing = true;
          totalStandardPrice += parseFloat(addon.standardPrice || 0);
          totalMembershipPrice += parseFloat(addon.membershipPrice || 0);
        }
      });
    } else if (typeof entry.addons === 'object' && entry.addons !== null) {
      // Complex addon object with groups
      Object.keys(entry.addons).forEach(groupKey => {
        const group = entry.addons[groupKey];
        if (Array.isArray(group)) {
          group.forEach(addon => {
            if (addon && addon.hasMembershipPricing) {
              hasAddonMembershipPricing = true;
              totalStandardPrice += parseFloat(addon.standardPrice || 0);
              totalMembershipPrice += parseFloat(addon.membershipPrice || 0);
            }
          });
        }
      });
    }

    if (hasAddonMembershipPricing) {
      standardPrice = totalStandardPrice;
      membershipPrice = totalMembershipPrice;
      hasMembershipDiscount = standardPrice > membershipPrice;
      priceDifference = (standardPrice - membershipPrice).toFixed(2);
      showMembershipDiscount = isUserLoggedIn && isAdvocadoProvider && hasMembershipDiscount;
      
                      // console.log('[SuccessInfo] Found addon membership pricing:', item.name, 'Standard:', standardPrice, 'Member:', membershipPrice, 'Diff:', priceDifference);
    }
  }

  // Calculate total price based on actual quantity
  const quantity = entry.quantity || (entry.addons && entry.addons.length) || 1;
  const totalStandardPrice = (standardPrice * quantity).toFixed(2);
  const totalPriceDifference = (priceDifference * quantity).toFixed(2);

  // Create price display based on membership status
  let extratag =
    actualPrice !== priceAmt ? (
      <p>
        <strike className="strikeprice">
          {cartStore.menuStore.currencySymbol +
            " " +
            parseFloat(actualPrice).toFixed(2)}
        </strike>
        {cartStore.menuStore.currencySymbol +
          " " +
          parseFloat(priceAmt).toFixed(2)}
      </p>
    ) : showMembershipDiscount ? (
      <div className="price-display">
        <span className="standard-price">
          {cartStore.menuStore.currencySymbol + " " + totalStandardPrice}
          </span>
        <div className="price-difference-amount">
          -{cartStore.menuStore.currencySymbol + " " + totalPriceDifference}
        </div>
      </div>
    ) : (
      <p>{cartStore.menuStore.currencySymbol + " " + parseFloat(priceAmt).toFixed(2)}</p>
    );

  let reward = entry.reward;
  let rewardDiv = "";
  if (reward && reward.redeem_code && reward.redeem_code !== "") {
    rewardDiv = <div className="disNameBg">{reward.redeem_name}</div>;
  }

  //let itemNotes= cartStore.getAddonsNamesList(entry.addons);
  return (
    <List>
      <Item
        wrap
        className="cart_item success_cart"
        thumb={<CartImg entry={entry} cartStore={cartStore} />}
        extra={extratag}
      >
        <div className="cartItemName">
          <div className="innerItemName">
            <p>{item.name}</p>
            {rewardDiv}
            <Brief>
              <RenderAddon addonSlected={entry.addons} />
              <RenderNotes entry={entry} />
            </Brief>
          </div>
        </div>
      </Item>
    </List>
  );
});
const CartImg = observer(({ entry, cartStore }) => {
  // Get quantity using the same logic as computeMembershipSavings
  let quantity = Number(entry.quantity) || Number(entry.qty) || Number((entry.item ? entry.item.quantity : undefined));
  
  // If quantity is not found, try to calculate from addons length
  if (!quantity || quantity === 0) {
    // Check if it's a simple array (even if Array.isArray fails)
    if (entry.addons && (Array.isArray(entry.addons) || (typeof entry.addons === 'object' && entry.addons.length !== undefined && typeof entry.addons.length === 'number'))) {
      // For simple addon arrays, count the length
      quantity = entry.addons.length || 1;
    } else if (entry.addons && typeof entry.addons === 'object' && !Array.isArray(entry.addons) && entry.addons.length === undefined) {
      // For complex addon structures, count total addons across all groups
      let totalAddons = 0;
      Object.keys(entry.addons).forEach(groupKey => {
        const group = entry.addons[groupKey];
        if (Array.isArray(group)) {
          totalAddons += group.length;
        }
      });
      quantity = totalAddons || 1;
    } else {
      // Fallback: try to count from notes array
      if (entry.notes && Array.isArray(entry.notes)) {
        quantity = entry.notes.length || 1;
      }
    }
  }
  
  // Final fallback
  quantity = quantity || 1;

  return (
    <div className="orderItemImage">
      <img src={entry.item.thumbnail} alt="" />
      <span>x{quantity}</span>
    </div>
  );
});
export default SuccessInfo;
